<template>
  <div class="c-industry">
    <sc-text v-if="fields && fields.label" :field="fields.label" class="label" />
    <sc-text tag="h4" v-if="fields && fields.heading" :field="fields.heading" class="headline" />
    <sc-link
      v-if="fields && fields.cta"
      :field="fields.cta"
      class="c-cta--tertiary"
      :class="fields.cta.value.class"
      >{{ fields?.cta?.value?.text }}
      <span class="sr-only"> {{ fields?.heading?.value }}</span></sc-link
    >
  </div>
</template>

<script>
import { Text, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Home-Industry',
  components: {
    ScText: Text,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.c-industry {
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: start;
  background-color: $white;
  padding: 4rem 2rem 1rem;
  border-top: solid 0.4rem $orange;
  box-shadow: 0 0.3rem 0.7rem 0 rgb(0 0 0 / 12%), 0 1.8rem 1.7rem 0 rgb(0 0 0 / 12%);
  margin-bottom: 1.2rem;

  .label {
    @include bug;
    border-radius: 0;
  }

  .headline {
    display: inline-block;
    @include font-styles('Arial', 2.4rem, 200, normal, 3rem, 0, $dark-blue);
    margin: 0 0 1rem 0;
  }

  .c-cta--tertiary {
    margin-bottom: 0;
    padding-left: 0;
    margin-top: auto;
  }
}
</style>
